
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/categories/[id]",
      function () {
        return require("private-next-pages/blog/categories/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/categories/[id]"])
      });
    }
  